import { TypographyP,TypographyH4 } from "@/components/ui/typography"
import Operation from "./components/operation" 
import { useCockpitQuery } from "@/queries/useCockpitQuery"
import { DatePicker } from "@/components/DatePicker"
import { useEffect, useState } from "react"
import { RefreshCw, Filter } from "lucide-react"
import CardSkeleton from "./components/cardSkeleton"
import { format,differenceInDays, addDays, subDays } from 'date-fns';
import { MultiSelect } from "@/components/MultiSelect"
import { Cockpit } from "@/api/business/cockpit/type"
import { Checkbox } from "@/components/ui/checkbox"
import { Input } from "@/components/ui/input"

import {
    NavigationMenu,
    NavigationMenuContent, 
    NavigationMenuItem, 
    NavigationMenuList,
    NavigationMenuTrigger, 
  } from "@/components/ui/navigation-menu"
import { Label } from "@/components/ui/label"
import { Separator } from "@/components/ui/separator"
import { Button } from "@/components/ui/button"

const Home = () => {
    const [initialDate, setInitialDate] = useState<Date>(new Date())
    const [finalDate, setFinalDate] = useState<Date>(new Date())
    const [supplier, setSupplier] = useState<string[]>([])
    const [selectSupplier, setSelectSupplier] = useState<string[]>([])
    const [cockpit, setCockpit] = useState<Cockpit[]>()
    const [purge, setPurge] = useState<Boolean>(false)
    const [doc, setDoc] = useState<string>('')
     

    let { data, isFetching, isPending, refetch }  = useCockpitQuery({initialDate: format(initialDate, 'yyyy-MM-dd')  , finalDate:  format(finalDate, 'yyyy-MM-dd'), doc   })
   
    useEffect(() => {
        if(data){
            let distinctSupplier = [...new Set(data.map(item => { 
                return item.OPERATIONS[0].NF.NM_RAZAO_SOCIAL
            }))]
           
            setSupplier(distinctSupplier)
            setSelectSupplier(distinctSupplier) 
            setCockpit(data)
        } 
    }, [data]);

    useEffect(() => {
        if(supplier && data){
            let filterCockpit = data.filter(item => supplier.includes(item.OPERATIONS[0].NF.NM_RAZAO_SOCIAL) )

            if(purge) { 
                filterCockpit = filterCockpit.filter( item => item.OPERATIONS.at(-1)?.NF.DD_NF_RECEBIDA == 0 || !item.OPERATIONS.at(-1)?.NF.DD_NF_RECEBIDA)
                filterCockpit = filterCockpit.filter( item => !(item.OPERATIONS[0].NF.DD_PROCESSO_HUB == 1 && item.OPERATIONS.at(-2)?.NF.DD_NF_RECEBIDA == 1))
                console.log(filterCockpit)
            }
            setCockpit(filterCockpit)
        }
    }, [supplier, purge]);

    const onChangeDate = ({DateInitial, DateFinal}) => {
        let differenceDays = 30
        if(DateInitial) {  
            if (differenceInDays(DateInitial, finalDate) < -differenceDays) {
                setInitialDate(DateInitial)
                setFinalDate(addDays(DateInitial,differenceDays)) 
            }
            if(DateInitial > finalDate){
                setInitialDate(DateInitial)
                setFinalDate(DateInitial)
            } else if (DateInitial <= finalDate) {
                setInitialDate(DateInitial)
            }
        }
        if(DateFinal) { 
            console.log(differenceInDays(initialDate, DateFinal) )
           if (differenceInDays(initialDate,DateFinal) < -differenceDays) {
               setInitialDate(subDays(DateFinal,differenceDays))
               setFinalDate(DateFinal) 
           }
           if(DateFinal < initialDate){
               setInitialDate(DateFinal)
               setFinalDate(DateFinal)
           } else if (DateFinal >= initialDate) {
                setFinalDate(DateFinal)
           }
       }
        
    }

    const resetFilter = () => {
        setInitialDate(new Date())
        setFinalDate(new Date())
        setPurge(false)
        setDoc('')
        refetch()
    }

    return (
        <div className="flex flex-col h-full overflow-auto p-4">
            <div>
                <TypographyP>Representação dos Status</TypographyP>
                <div className="flex gap-2 my-2">
                    <div className="bg-intransport p-1 text-sm rounded">Em transporte</div>
                    <div className="bg-waitingknowledge p-1 text-sm rounded">Aguardando conhecimento</div>
                    <div className="bg-warning p-1 text-sm rounded">Com impeditivo</div>
                    <div className="bg-timeout p-1 text-sm rounded">Tempo esgotado</div>
                    <div className="bg-completed p-1 text-sm rounded">Processo concluido</div>
                </div>
            </div>
            <div>
                <div className="flex justify-between items-center">
                    <TypographyH4>Cockpit</TypographyH4> 
                    <div className="flex gap-4 items-center">
                        <div>
                            <Button 
                                className="w-full md:py-3 bg-gray-900 hover:bg-gray-800" 
                                onClick={() => resetFilter()}
                            >
                                Resetar filtros
                            </Button>
                        </div>
                        <div>
                            <div className="flex items-center space-x-2">
                            <NavigationMenu>
                            <NavigationMenuList>
                                <NavigationMenuItem>
                                    <NavigationMenuTrigger>
                                        <Filter />
                                    </NavigationMenuTrigger>
                                    <NavigationMenuContent > 
                                        <div className="w-[300px] p-4 grid gap-4">
                                            <div className="flex items-center space-x-2">
                                                <Checkbox id="checkpurge" className="bg-gray-400" onCheckedChange={(item) => setPurge(Boolean(item))}/>
                                                <label
                                                    htmlFor="checkpurge"
                                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                                >
                                                    Expurgar operações concluidas
                                                </label>
                                            </div> 
                                            <Separator />
                                            <div className="min-w-[250px]">
                                                <MultiSelect 
                                                    placeholder="Fornecedor"
                                                    onChange={(value) => {
                                                            let allSupplier = [...supplier]

                                                            const index = allSupplier.indexOf(value.toLocaleUpperCase());
                                                            console.log(index)
                                                            if (index !== -1) { 
                                                                allSupplier.splice(index, 1);
                                                            } else { 
                                                                allSupplier.push(value.toLocaleUpperCase());
                                                            }
                                                            console.log(allSupplier)
                                                            setSupplier(allSupplier) 
                                                        }
                                                    }  
                                                    onSelectAll={(values) => 
                                                        setSupplier(values)
                                                    } 
                                                    options={selectSupplier.map(
                                                        (supp) => ({
                                                            label: supp,
                                                            value: supp,
                                                        })
                                                    )}
                                                    selectedValues={supplier} 
                                                    label="Selecionar Fornecedor"

                                                />
                                            </div>
                                            <Separator />
                                            <div>
                                                <div className="grid w-full max-w-sm items-center gap-1.5">
                                                    <Label htmlFor="DD_DOC">Número Documento</Label>
                                                    <Input id="DD_DOC" value={doc} onChange={(event) => setDoc(event.target.value)}  className='w-full border-2 border-gray-500 text-sm rounded-md px-4 py-2 text-gray-50 outline-none focus:border-primary-500' />
                                                    <Button 
                                                        className="w-full md:py-3 bg-gray-400 hover:bg-gray-700" 
                                                        onClick={() => refetch()}
                                                    >
                                                        Buscar
                                                    </Button>
                                                </div>
                                            </div>
                                        </div> 
                                    </NavigationMenuContent> 
                                </NavigationMenuItem>
                            </NavigationMenuList>
                            </NavigationMenu>
                            </div> 
                        </div> 

                        <div className="flex gap-1 items-center">
                            <span>Emissão entre: </span>
                            <DatePicker date={initialDate} setDate={(date) => date && onChangeDate({DateInitial: date, DateFinal: null})} classNames={{day_selected: 'focus:bg-gray-400'}} />
                            <DatePicker date={finalDate} setDate={(date) => date && onChangeDate({DateInitial: null, DateFinal: date}) } classNames={{day_selected: 'focus:bg-gray-400'}} />
                            <button
                                className={`${isFetching ? 'animate-spin' : ''} ml-2`}
                                onClick={() => refetch()}
                            >
                                <RefreshCw className="w-5 md:w-6" />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="flex flex-wrap gap-2 mt-2">
                    {(cockpit && !isPending) && cockpit.map((value, index) => (
                        <Operation operation={value} key={index}></Operation>
                    ))}
                    {isPending && Array.from(Array(7).keys()).map((number) => ( <CardSkeleton key={number} />  ))}
                </div>
            </div>
        </div>
    )
}

export default Home
